module.exports = __webpack_public_path__ + "static/media/Wipro_1.d54e2ae6.png";